import { render, staticRenderFns } from "./fhir-config.vue?vue&type=template&id=6390533b&scoped=true"
import script from "./fhir-config.vue?vue&type=script&lang=js"
export * from "./fhir-config.vue?vue&type=script&lang=js"
import style0 from "./fhir-config.vue?vue&type=style&index=0&id=6390533b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6390533b",
  null
  
)

export default component.exports